if(window.location.href === "https://momiji-home.com/")
{
  document.querySelector('.iy1y9IUF5DxMdi0J8').setAttribute('href', 'https://momiji-home.com/collections/all-adult-furniture');        
        document.addEventListener("DOMContentLoaded", (event) => {
          const button = document.querySelector('.instant-slider-button.instant-slider-button-next.instant-slider-uzFCOXHp4BquBYkG-button-next.itJyVoMRfe4tSdD3l');
          const targetDiv = document.querySelector('.instant-slider-container.iKjfgLDXNQa0OrENx');
          let intervalId;

          const observer = new IntersectionObserver((entries, observer) => {
              entries.forEach(entry => {
                  if (entry.isIntersecting) {
                      intervalId = setInterval(function() {
                          button.click();
                      }, 3000);
                  } else {
                      clearInterval(intervalId);
                  }
              });
          }, { threshold: .5 });
          observer.observe(targetDiv);
        });
  
        const sliderParent = document.getElementById('DawnZp1stobWHJqc');
        const slider = sliderParent.querySelector('.instant-slider-wrapper');
        const speed = 0.5;
        let isPaused = false;
        slider.style.transitionDuration = '0ms';
        slider.style.transitionDelay = '0ms';
        
        function getCurrentTranslateX() {
            const transformMatrix = window.getComputedStyle(slider).getPropertyValue('transform');
            
            if (transformMatrix !== 'none') {
                const matrixValues = transformMatrix.match(/matrix.*\((.+)\)/)[1].split(', ');
                return parseFloat(matrixValues[4]);
            } else {
                return 0;
            }
        }
        
        const windowWidth = window.innerWidth;
        let maximumXPosition = 0;
        if(windowWidth >= 375) {
            maximumXPosition = -2300;
        } else if(windowWidth <= 425) {
            maximumXPosition = -2696;
        } else if (windowWidth <= 575 && windowWidth > 425) {
            maximumXPosition = -3890;
        } else if(windowWidth >= 768) {
            maximumXPosition = -5350;
        }
        
        setInterval(function() {
            if (!isPaused) {
                if (getCurrentTranslateX() > maximumXPosition) {
                    let currentpos = getCurrentTranslateX();
                    currentpos -= speed;
                    slider.style.transform = `translate3d(${currentpos}px, 0, 0)`;  
                }
            }
        }, 16);        
        slider.addEventListener('mouseenter', function() {
            isPaused = true;
        });        
        slider.addEventListener('mouseleave', function() {
            isPaused = false;
        });        
        const sliderObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    isPaused = false;
                } else {
                    isPaused = true;
                }
            });
        }, { threshold: 0.1 });        
        sliderObserver.observe(slider);
}

document.addEventListener("DOMContentLoaded", function() {
const productCards = document.querySelectorAll('.product-card-imagecontainer');

productCards.forEach(function(imageContainer) {
    const images = imageContainer.querySelectorAll('.product-image');
    let currentIndex = 0;
    let hoverInterval = null;

    function startCycling() {
      hoverInterval = setInterval(function() {
        images[currentIndex].style.opacity = 0;
        currentIndex = (currentIndex + 1) % images.length;
        images[currentIndex].style.opacity = 1;
      }, 750);
    }

    function resetImages() {
      images.forEach(function(image, index) {
        image.style.opacity = index === 0 ? 1 : 0;
      });
      currentIndex = 0;
    }

    imageContainer.addEventListener('mouseenter', function() {
      if (hoverInterval) {
        clearInterval(hoverInterval);
      }
      startCycling();
    });

    imageContainer.addEventListener('mouseleave', function() {
      if (hoverInterval) {
        clearInterval(hoverInterval);
      }

      resetImages();
    });
  });
});

//add a dropdown menu to the popup

const intervalId = setInterval(() => {
const shadowHost = document.querySelector('#pop-convert-app');
if (shadowHost) {
    const shadowRoot = shadowHost.shadowRoot;
    const targetDiv = shadowRoot.getElementById('block-1');

    if (targetDiv)
    {
      targetDiv.innerHTML += `
        <div class="popup-flagcontainer" style="margin-top: 8px; display: flex;flex-direction:row;align-items: center;justify-content: center;">
          <!--<a href="https://momiji-home.com/"><img style="margin-right: 8px;" src="//cdn.shopify.com/static/images/flags/us.svg?format=jpg&amp;width=60" alt="United States" srcset="//cdn.shopify.com/static/images/flags/us.svg?format=jpg&amp;width=60 60w" width="60" height="45" class="country-flag"></a>-->
          <a href="https://momiji.sg/"><img style="margin-right: 8px;" src="//cdn.shopify.com/static/images/flags/sg.svg?format=jpg&amp;width=60" alt="Singapore" srcset="//cdn.shopify.com/static/images/flags/sg.svg?format=jpg&amp;width=60 60w" width="60" height="45" class="country-flag"></a>
          <!--<a href="https://momiji-home.com/"><img style="margin-right: 8px;" src="//cdn.shopify.com/static/images/flags/id.svg?format=jpg&amp;width=60" alt="Indonesia" srcset="//cdn.shopify.com/static/images/flags/id.svg?format=jpg&amp;width=60 60w" width="60" height="45" class="country-flag"></a>-->
        </div>`;
      console.log("popup-flagcontainer");
      clearInterval(intervalId);
    }
  }
}, 500);